import React from "react";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
  DrawerFooter,
  DrawerClose,
} from "@/components/ui/drawer";
import { cn } from "@/lib/utils";

/**
 * BottomSheet — mobile-first slide-up sheet built on shadcn Drawer (vaul).
 * Includes drag-handle, swipe-down-to-dismiss, focus-trap, and safe-area inset.
 *
 * Usage:
 *   <BottomSheet open={open} onOpenChange={setOpen} title="Edit Task" description="...">
 *     {body}
 *     <BottomSheetFooter>
 *       <button>Save</button>
 *     </BottomSheetFooter>
 *   </BottomSheet>
 */
export function BottomSheet({
  open,
  onOpenChange,
  title,
  description,
  children,
  className,
  dismissible = true,
}) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} dismissible={dismissible}>
      <DrawerContent
        className={cn(
          "bg-[var(--s0,#0a0a0a)] border-t border-[var(--bdr)]",
          "pb-[env(safe-area-inset-bottom)]",
          className
        )}
      >
        {(title || description) && (
          <DrawerHeader className="text-left">
            {title && <DrawerTitle className="font-heading text-[var(--t1)]">{title}</DrawerTitle>}
            {description && (
              <DrawerDescription className="text-[var(--t3)] text-sm">{description}</DrawerDescription>
            )}
          </DrawerHeader>
        )}
        <div className="px-4 pb-4 overflow-y-auto max-h-[calc(85vh-4rem)]">{children}</div>
      </DrawerContent>
    </Drawer>
  );
}

export function BottomSheetFooter({ children, className }) {
  return (
    <DrawerFooter className={cn("border-t border-[var(--bdr)] pt-3", className)}>
      {children}
    </DrawerFooter>
  );
}

export { DrawerClose as BottomSheetClose };

export default BottomSheet;
